<template>
  <section class="section">
    <h1 class="title is-4">Detalle de la carga {{ uuid }}</h1>
    <div v-if="work.id">
      <p><strong>Hospital: </strong>{{ work.company.code }} - {{ work.company.name }}</p>

      <p class="mb-4"><strong>Fecha: </strong>{{ work.date }}</p>

      <section class="controls columns is-multiline">
        <div class="column is-6">
          <div class="block">
            <b-radio v-model="params.type_labels"
                     native-value="both">
              Ambas
            </b-radio>
            <b-radio v-model="params.type_labels"
                     native-value="doc">
              Documentos
            </b-radio>
            <b-radio v-model="params.type_labels"
                     native-value="labels">
              Recipientes
            </b-radio>
          </div>
        </div>
        <div class="column is-6">
          <b-field>
            <b-button
              @click="onPrintLabels"
              type="is-primary" >
              Imprimir etiquetas
            </b-button>
          </b-field>
        </div>
      </section>

      <div class="table-container">
        <b-table
          :data="work.entries"
          :striped="true"
          :mobile-cards="true"
          :row-class="getRowClass"
        >
          <template #empty>
            <section class="section has-text-centered">
              <p>Por favor seleccione un archivo válido</p>
            </section>
          </template>

          <b-table-column field="name" label="Nombre" v-slot="props">
            {{ props.row.data.name }}
          </b-table-column>

          <b-table-column field="last_name" label="Paterno" v-slot="props">
            {{ props.row.data.last_name }}
          </b-table-column>

          <b-table-column field="other_name" label="Materno" v-slot="props">
            {{ props.row.data.other_name }}
          </b-table-column>

          <b-table-column field="folio" label="Folio Paciente" v-slot="props">
            {{ props.row.data.folio }}
          </b-table-column>

          <b-table-column field="birthdate" label="Nacimiento" v-slot="props">
            {{ props.row.data.birthdate }}
          </b-table-column>

          <b-table-column field="sex" label="Sexo" v-slot="props">
            {{ props.row.data.sex }}
          </b-table-column>

          <b-table-column field="study" label="Estudio" v-slot="props">
            <div v-for="study in props.row.data.studies" :key="study.lapi_code" style="margin-bottom: .5rem;">
              <strong>{{ study.sedena_name }}</strong><br />
              <small>{{ study.lapi_code }} - {{ study.lapi_description }}</small>
            </div>
          </b-table-column>

          <b-table-column field="order" label="OrdenNew" v-slot="props">
            {{ props.row.OrdenNew }}
          </b-table-column>

          <b-table-column field="status" label="Estado" v-slot="props">
            {{ props.row.statusFormatted }}
            <p v-if="props.row.status === 'failed'"><strong>Error: <span class="color-red">{{ props.row.errors }}</span></strong></p>
            <br>
            <b-button
              v-if="props.row.status === 'completed'"
              type="is-primary" outlined @click="handleOrderPrint(props.row.order.id)">Imprimir</b-button>
          </b-table-column>
        </b-table>
      </div>
    </div>
  </section>
</template>

<script>
import ModalPrint from "@/components/print/ModalPrint";
export default {
  name: "Show",
  components: {
    ModalPrint
  },
  props: {
    uuid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      work: {},
      intervalId: null,
      params: {
        copies: 2,
        type: 'normal',
        type_labels: 'both',
        label_doc_copies: 1,
        label_container_copies: 1,
        samples: [],
      },
      allCompleted: false
    };
  },
  mounted() {
    this.wrapper = document.getElementById('main-wrapper');
    this.wrapper.classList.add('is-expanded');
    this.prepareData();
    this.intervalId = setInterval(() => {
      this.prepareData();
    }, 10000)
  },
  methods: {
    prepareData() {
      this.$loader.show();
      this.$http.get(`/sedena/work/${this.uuid}`).then(({ data }) => {
        this.work = data.data || null;
        if(this.work.entries.every(w => w.status === 'completed')) {
          this.allCompleted = true;
          if(this.intervalId){
            clearInterval(this.intervalId);
          }
        }
      }).catch(err => {
      }).finally(() => {
        this.$loader.hide();
      });
    },
    getRowClass(row, index) {
      const rowClass = {
        'pending': 'sedena-row-pending',
        'processing': 'sedena-row-processing',
        'completed': 'sedena-row-completed',
        'failed': 'sedena-row-has-errors'
      }
      return rowClass[row.status] || '';
    },
    onPrintLabels(){
      this.$loader.show();
      const printer = Number.parseInt(localStorage.getItem('printerManager_printer')) || 1;
      this.$http.post(`sedena/print-labels/${this.uuid}`, {
        type_labels: this.params.type_labels,
        printer
      }).then(() => {
        this.$buefy.toast.open({
          message: 'Se han enviado las etiquetas a imprimir',
          type: 'is-success'
        });
      }).finally(() => {
        this.$loader.hide();
      });
    },
    handleOrderPrint(order_id){
     // console.log('Imprimir orden', order_id);
      this.$loader.show();
      this.$http.get(`/sedena/orders/${order_id}`).then(({ data }) => {
        //console.log(data.data);
        this.$buefy.modal.open({
          component: ModalPrint,
          hasModalCard: true,
          props: {
            data: data.data,
            hasCompany: !!data.company,
            company: data.company
          },
          width: '800px',
          animation: 'fade',
        });
      }).finally(()=> {
        this.$loader.hide();
      })
    }
  },
  beforeDestroy(){
    if(this.intervalId){
      clearInterval(this.intervalId);
    }
  }
};
</script>

<style scoped>
.color-red {
  color: darkred;
}
</style>